"use strict";

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/classCallCheck");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var cameras_1 = __importDefault(require("./cameras"));
var mobiles_1 = __importDefault(require("./mobiles"));
var televisions_1 = __importDefault(require("./televisions"));
var cars_1 = __importDefault(require("./cars"));
var consoles_1 = __importDefault(require("./consoles"));
var portable_media_players_1 = __importDefault(require("./portable-media-players"));
var deviceParsers = [consoles_1.default, cars_1.default, cameras_1.default, televisions_1.default, portable_media_players_1.default, mobiles_1.default];
var ClientParser = /*#__PURE__*/_createClass(function ClientParser() {
  _classCallCheck(this, ClientParser);
  this.parse = function (userAgent) {
    for (var _i = 0, _deviceParsers = deviceParsers; _i < _deviceParsers.length; _i++) {
      var Parser = _deviceParsers[_i];
      var parser = new Parser();
      var device = parser.parse(userAgent);
      if (device.type !== "") {
        return device;
      }
    }
    return null;
  };
});
exports.default = ClientParser;